import apiClient from './apiClient';
import { ApiResponse, PaginatedResponse } from '../../types/common';
import { User, UserFilters } from '../../types/user';

export const getUsers = async (filters: UserFilters): Promise<PaginatedResponse<User>> => {
  const response = await apiClient.get<ApiResponse<PaginatedResponse<User>>>('/admin/users', {
    params: { ...filters, page: filters.page + 1 },
  });

  if (response.data.status !== 200 || !response.data.data) {
    throw new Error(response.data.message || '사용자 목록 조회에 실패했습니다.');
  }

  return response.data.data;
};

export const getUserById = async (id: string): Promise<any> => {
  const response = await apiClient.get<ApiResponse<any>>(`/admin/users/${id}`);

  if (response.data.status !== 200 || !response.data.data) {
    throw new Error(response.data.message || '사용자 정보 조회에 실패했습니다.');
  }

  return response.data.data;
};

export const updateUser = async (
  id: string,
  data: Partial<User>
): Promise<User> => {
  const response = await apiClient.put<ApiResponse<User>>(`/admin/users/${id}`, data);

  if (response.data.status !== 200 || !response.data.data) {
    throw new Error(response.data.message || '사용자 정보 수정에 실패했습니다.');
  }

  return response.data.data;
};
